// eslint-disable-next-line no-unused-vars
import React from 'react'
import { withRouter } from 'router'

const PublicLayout = ({ children }) => {
  return children
}

export default withRouter(PublicLayout)
